//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class CustomEmoji extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'CustomEmoji';
  }
}
CustomEmoji.initClass();

export { CustomEmoji };
